var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from './BaseModel';
var DefaultChoiceModel = /** @class */ (function (_super) {
    __extends(DefaultChoiceModel, _super);
    function DefaultChoiceModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.id = hydrated.gcid;
        _this.excluded = hydrated.excluded;
        _this.gcid = hydrated.gcid;
        _this.included = hydrated.included;
        _this.includedQuantity = hydrated.includedQuantity;
        _this.ocid = hydrated.ocid;
        _this.priceDelta = hydrated.priceDelta;
        _this.__mc = 'DefaultChoiceModel';
        return _this;
    }
    DefaultChoiceModel.prototype.hydrate = function (data) {
        var hydrated = {
            excluded: data.excluded,
            gcid: data.gcid,
            included: data.included,
            includedQuantity: data.included_qty || 0,
            ocid: data.ocid || '',
            priceDelta: parseInt(data.price_delta) || 0
        };
        return hydrated;
    };
    DefaultChoiceModel.prototype.hydrateFromStore = function (data) {
        return data;
    };
    return DefaultChoiceModel;
}(BaseModel));
export default DefaultChoiceModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/DefaultChoiceModel.ts
// module id = /hHB
// module chunks = 18